import {
  faFileAudio,
  faFileImage,
  faFilePdf,
  faFileVideo,
  faPaperclip,
} from "@fortawesome/duotone-light-svg-icons"
import { faDownload } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@joonapp/web-shared"
import { JoonUIColor } from "@joonapp/web-shared"

const AttachmentItem = ({
  name,
  url,
  className,
}: {
  name: string
  url: string
  className?: string
}) => {
  const splitName = name.split(".")
  const attachmentType = splitName[splitName.length - 1]

  const icon = getAttachmentIcon(attachmentType)

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    window.open(url, "_blank")
  }

  return (
    <div
      className={`border border-borderPrimary bg-white rounded-md ${className} w-full`}
    >
      <button onClick={handleClick} className="flex flex-col w-full">
        {["png", "jpg", "jpeg", "gif"].includes(attachmentType) && (
          <div className="border-b border-borderPrimary w-full">
            <img
              src={url}
              alt={name}
              className="max-h-[120px] object-cover w-full"
            />
          </div>
        )}
        <div className="flex flex-row items-center gap-2 p-2">
          <div className="flex flex-row gap-2 items-center hover:underline">
            <FontAwesomeIcon
              icon={icon}
              fontSize={16}
              color={JoonUIColor.icon.accent}
            />
            <Typography variant="bodySmall" className="truncate">
              {name}
            </Typography>
          </div>

          <FontAwesomeIcon
            icon={faDownload}
            fontSize={16}
            color={JoonUIColor.icon.accent}
            className="ml-auto"
          />
        </div>
      </button>
    </div>
  )
}

export default AttachmentItem

const getAttachmentIcon = (attachmentType: string | undefined) => {
  if (!attachmentType) return faPaperclip

  if (["png", "jpg", "jpeg", "gif"].includes(attachmentType)) return faFileImage
  if (["mp4", "mov", "avi", "mkv"].includes(attachmentType)) return faFileVideo
  if (["mp3", "wav", "m4a"].includes(attachmentType)) return faFileAudio
  if (["pdf"].includes(attachmentType)) return faFilePdf
  return faPaperclip
}
